import React from 'react';
import './LandingPage.css';

export const clientID = process.env.REACT_APP_SPOTIFY_CLIENT_ID;
export const redirectUri = process.env.NODE_ENV === "production" 
    ? "https://www.tbsm.xyz/callback"
    : "http://localhost:3000/callback";  // or wherever you're running locally
export const SCOPES = ["user-top-read"];  // Add more or adjust as per your app's needs

export const AUTH_URL = "https://accounts.spotify.com/authorize" +
    "?client_id=" + clientID +
    "&response_type=token" + 
    "&redirect_uri=" + encodeURIComponent(redirectUri) +
    "&scope=" + encodeURIComponent(SCOPES.join(" "));

export function LoginButton() {
  return (
    <div className="landing-page">
    <h1>LUNCHBREAK BLR LISTENING SESSION</h1>
      <div className="images-container">
        <img src="/lunchbreak.jpeg" alt="Lunchbreak Album Cover" />
      </div>
      <div className="greeting">
        <p>GM fam, <span className="highlight">@srijancse</span> here! 🎶</p>
        <p>So, here's the tea: Tonight in Indiranagar, as the clock strikes midnight, <span className="highlight">Seedhe Maut's</span> latest banger mixtape <span className="highlight">LUNCHBREAK</span> is releasing and guess what? </p>
        <p>We are doing a listening session.Wanna jump in? Here's the game plan:</p>
        <br></br>
         <p> <span className="highlight">Login with Spotify</span>  (web-only, sorry!) below to see if Seedhe Maut's hanging out in your Top Artists list. If they are (I mean, why wouldn't they be? 🎧), you get a password! That's literally your pass to RSVPing for the listening session.</p>
      </div>
      <a href={AUTH_URL} className="spotify-button">Login with Spotify</a>
    </div>
  );
}

